var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCubeOutline = function SvgCubeOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333,
    d: "m5.5 13.833.982.546c.189.105.284.158.384.178q.134.027.268 0c.1-.02.195-.073.384-.178l.982-.546m-6-1.666-.951-.529c-.2-.11-.3-.166-.373-.245a.7.7 0 0 1-.142-.243C1 11.048 1 10.934 1 10.706v-1.04m0-3.333V5.294c0-.228 0-.342.034-.444a.7.7 0 0 1 .142-.243c.073-.079.173-.134.373-.245l.951-.529m3-1.666.982-.546c.189-.105.284-.157.384-.178a.7.7 0 0 1 .268 0c.1.02.195.073.384.178l.982.546m3 1.666.951.529c.2.11.3.166.373.245q.097.107.142.243c.034.102.034.216.034.444v1.04m0 3.333v1.039c0 .228 0 .342-.034.444a.7.7 0 0 1-.142.243c-.073.079-.173.134-.373.245l-.951.529m-6-5L7 8m0 0 1.5-.833M7 8v1.667m-6-5 1.5.833m9 0 1.5-.833M7 13v1.667"
  })));
};
export default SvgCubeOutline;